import { useEffect, useRef, useState } from 'react';

const FAQS = [
  {
    q: 'What is The Reve Foundation?',
    a: 'The Reve Foundation is a private charitable foundation based in Palo Alto, California. It exists to support meaningful charitable work and to approach giving with care, consideration and a long-term view.',
  },
  {
    q: 'How do I contact the foundation?',
    a: 'You can email Sherri Davis at sherri@therevefoundation.com, send a note through the form on this page, or write to 550 Hamilton Ave, Palo Alto, CA 94301, United States.',
  },
  {
    q: 'What does the foundation focus on?',
    a: 'Our stated principles are purposeful giving, community well-being and long-term impact. We do not publish details of specific programmes, grantees or funding decisions here.',
  },
  {
    q: 'Can I request funding or submit a proposal?',
    a: 'We have not published a grant application process. If you would like to reach out, please use the contact details on this page and we will respond as we are able.',
  },
  {
    q: 'Are donations accepted from the public?',
    a: 'The Reve Foundation is a private foundation and does not solicit contributions through this website. For any question about giving, please get in touch by email.',
  },
];

type FaqItemProps = {
  index: number;
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
};

function FaqItem({ index, question, answer, isOpen, onToggle }: FaqItemProps) {
  const innerRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const el = innerRef.current;
    if (!el) return undefined;
    const measure = () => setHeight(el.scrollHeight);
    measure();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', measure);
      return () => window.removeEventListener('resize', measure);
    }
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [answer]);

  return (
    <div className="faq-row" data-reveal>
      <div className={`faq-item ${isOpen ? 'is-open' : ''}`}>
        <button
          type="button"
          aria-expanded={isOpen}
          aria-controls={`faq-answer-${index}`}
          onClick={onToggle}
        >
          <span>{question}</span>
          <i className="ri-add-line" aria-hidden="true" />
        </button>
        <div
          className="faq-answer"
          id={`faq-answer-${index}`}
          role="region"
          style={{ height: isOpen ? height : 0 }}
        >
          <div className="faq-answer-inner" ref={innerRef}>
            <p>{answer}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="faq-band" id="faq" aria-labelledby="faq-heading">
      <div className="faq-inner">
        <p className="stamp" data-reveal>
          Common questions
        </p>
        <h2 id="faq-heading" data-reveal>
          Before you <em className="accent">write</em> to us.
        </h2>

        <div className="faq-list">
          {FAQS.map((item, i) => (
            <FaqItem
              key={item.q}
              index={i}
              question={item.q}
              answer={item.a}
              isOpen={open === i}
              onToggle={() => setOpen(open === i ? null : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}